import { render, staticRenderFns } from "./SuccessAlert.vue?vue&type=template&id=621ccf08&scoped=true&"
import script from "./SuccessAlert.vue?vue&type=script&lang=js&"
export * from "./SuccessAlert.vue?vue&type=script&lang=js&"
import style0 from "./SuccessAlert.vue?vue&type=style&index=0&id=621ccf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ccf08",
  null
  
)

export default component.exports